/**
 * Adds 's' to a word if the number is greater than 1
 * @param count - The number to check
 * @param singular - The singular form of the word
 * @returns The word with 's' added if count > 1, otherwise the singular form
 */
export const pluralize = (count: number, singular: string): string => {
  return count === 0 || count > 1 ? `${singular}s` : singular;
};
